import { useEffect } from 'react';

export const useUnmount = (fn: () => void | undefined) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fn, []);
};
